import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive({
    selector: '[libInsertRouteTitle]',
    standalone: true,
})
export class InsertRouteTitleDirective implements OnInit {
    public constructor(
        private readonly route: ActivatedRoute,
        private readonly renderer: Renderer2,
        private readonly element: ElementRef,
    ) {}

    public ngOnInit() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const titleText = this.renderer.createText(this.route.snapshot.title ?? '');
        this.renderer.appendChild(this.element.nativeElement, titleText);
    }
}
